<template>
  <div id="uyh-img-capture">
    <div class="capture-container">
      <svg svg-inline="" class="close" @click="closeAndDisconnect" role="presentation" focusable="false" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle cx="15" cy="15" r="15"/><path d="M8.726 21.72a.795.795 0 0 0 1.143 0l5.09-5.089 5.089 5.09a.816.816 0 0 0 1.143.086c.345-.28.366-.798.086-1.143-.022-.022-.043-.065-.086-.086l-5.09-5.089 5.089-5.09a.814.814 0 0 0 .043-1.142.814.814 0 0 0-1.143-.043l-.043.043-5.088 5.09-5.09-5.09a.815.815 0 0 0-1.143.044.824.824 0 0 0 0 1.1l5.09 5.088-5.09 5.09a.834.834 0 0 0 0 1.142z" fill="#000"/></g></svg>
      <p class="cta-text">{{ $t('get_image.capture_image') }}</p>
      <div class="image-capture-area">
        <video id="video" autoplay></video>
        <canvas id="canvas"></canvas>
      </div>

      <button class="uyh-btn secondary" @click="takeImage">{{ $t('get_image.take') }}</button>
      <button class="uyh-btn secondary disabled" id="next" @click="editMantra">{{ $t('navigation.next') }}</button>
    </div>
  </div>
</template>

<script>
  import getCookie from '@/assets/javascripts/get_cookie'

  export default {
    methods: {
      takeImage: function(e) {
        var captureArea = document.querySelector('.image-capture-area');
        var player = document.getElementById('video');
        var visualCanvas = document.getElementById('canvas');
        visualCanvas.height = player.offsetHeight;
        visualCanvas.width = player.offsetWidth;
        var visualContext = visualCanvas.getContext('2d');
        this.updateDataLayer(e.target.innerText);

        // Visual canvas draw for user acceptance
        visualContext.drawImage(player, 0, 0, visualCanvas.offsetWidth, visualCanvas.height);
        var imageUrl = visualCanvas.toDataURL('image/jpge');

        // Draw to add element to body for next step
        var img = new Image();
        img.onload = function() {
          var deleteCanvas = document.getElementById('hidden-canvas');
          if (deleteCanvas) {
            deleteCanvas.parentNode.removeChild(deleteCanvas);
          }
          var canvas = document.createElement('canvas');
          canvas.style.display = 'none';
          canvas.id = 'hidden-canvas';
          canvas.width = 340;
          canvas.height = 510;
          var ctx = canvas.getContext('2d');
          var offsetValue = (img.naturalWidth - captureArea.offsetWidth) / 2;
          ctx.drawImage(img, offsetValue, 0, captureArea.offsetWidth, img.naturalHeight, 0, 0, canvas.width, canvas.height);
          document.body.appendChild(canvas);
          document.getElementById('next').classList.remove('disabled');
        }
        img.src = imageUrl;

      },
      closeAndDisconnect: function() {
        var player = document.getElementById('video');
        if (player && player.srcObject) {
          player.srcObject.getVideoTracks().forEach(track => track.stop());
        }
        this.$emit('hide-take-picture');
      },
      editMantra:function() {
        var activeSlide = document.querySelector('.slick-current');
        var link = '/send-message/' + activeSlide.querySelector('.uyh-background.primary').dataset.template + '/image';
        if (link.includes('#')) {
          link = link.split('#')[1];
        }
        this.closeAndDisconnect();
        this.$router.push(link);
      },
      updateDataLayer: function(title) {
        window.dataLayer.push({
          'event': 'nav-click',
          'clickPath': '',
          'clickTitle': title,
          'locale': getCookie('lang')
        });
      }
    },
    mounted: function() {
      document.getElementById('uyh-app').classList.add('frozen');
      var $this = this;
      var player = document.getElementById('video');
      var constraints = {
        audio: false,
        video: {
          facingMode: "user"
        }
      }

      // Browser-specific compatibility
      navigator.getUserMedia = (navigator.getUserMedia ||
                                navigator.webkitGetUserMedia ||
                                navigator.mozGetUserMedia ||
                                navigator.msGetUserMedia);

      navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        player.srcObject = stream
      }).catch(function(){
        alert($this.$t('get_image.camera_error'));
        $this.closeAndDisconnect();
      });
    },
    destroyed: function() {
      document.getElementById('uyh-app').classList.remove('frozen');
    }
  }
</script>


<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    $mobile-breakpoint: 767px;
    $tablet-portrait-down-breakpoint: 1023px;
    $tablet-down-breakpoint: 1199px;
    $tablet-breakpoint: 1200px;
    $hd-desktop-breakpoint: 1280px;

    #uyh-img-capture {
      background-color: rgba(0,0,0,0.75);
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100vw;
      z-index: 19;

      .close {
        cursor: pointer;
        position: absolute;
        right: 27px;
        top: 13px;
        path {
          fill: #fceff3;
        }
      }

      .cta-text {
        color: #fceff3;
        display: block;
        font-size: 25px;
        margin: 0 auto;
      }

      .capture-container {
        background-color: #223628;
        left: 50%;
        max-height: 100vh;
        max-width: 100%;
        min-height: calc(100% - 70px);
        padding: 36px 0;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 1000px;
        .image-capture-area {
          border: 1px dashed #fceff3;
          display: block;
          margin: 40px auto;
          overflow: hidden;
          position: relative;
          width: calc(2 / 5 * 100%);
          &:before {
            content: '';
            display: block;
            padding-top: calc(3 / 2 * 100%);
          }
          #video,
          #canvas {
            height: 100%;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            width: auto;
          }
        }
        .uyh-btn {
          display: inline-block;
          margin: 0 38.75px;
          &.disabled {
            cursor: default;
            opacity: 0.6;
            pointer-events: none;
            &:hover {
              background-color: transparent;
              border: 1px solid #fceff3;
              color: #fceff3;
            }
          }
        }
      }
      @media screen and (min-width: $tablet-breakpoint) and (max-width: $hd-desktop-breakpoint) {
        .capture-container {
          padding: 24px 0;
          .image-capture-area {
            margin: 24px auto;
            width: calc((2 / 5 * 100%) - 115px);
          }
        }
      }
    }
  }
</style>
